export class UOMGroupDetails {
  UOMGroupCode: string;
  UOMCode: string;
  SerialNumber: number;
  UnitFragment: number;    
}
